import CheckList from "components/CheckList";
import type { CheckListProps } from "components/CheckList";
import type { ReactStoryblokComponent } from "../types";

const CheckListAdapter = ({
  blok: {
    heading,
    bgColor = "greyscale.200",
    iconPosition = "flex-start",
    containerFilling = "contain",
    listItems: storyblokListItems,
    fontSize = "lg",
  },
}: ReactStoryblokComponent<CheckListProps>) => {
  const listItems = storyblokListItems.map(({ _uid, text, iconType = "success" }) => ({ _uid, text, iconType }));

  return (
    <CheckList
      heading={heading}
      bgColor={bgColor}
      iconPosition={iconPosition}
      containerFilling={containerFilling}
      fontSize={fontSize}
      listItems={listItems}
    />
  );
};

export default CheckListAdapter;
